export default {
    host: 'https://analytics.fuelguide.be',
    siteId: '1',
    requireCookieConsent: true,
    trackExternalLinks: true,
}